var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsInterview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9444 5.74523H20.3889C20.6836 5.74523 20.9662 5.86229 21.1746 6.07066C21.3829 6.27904 21.5 6.56165 21.5 6.85634V19.0786L17.7967 16.0019C17.5968 15.836 17.3453 15.7452 17.0856 15.7452H8.16667C7.87198 15.7452 7.58937 15.6282 7.38099 15.4198C7.17262 15.2114 7.05556 14.9288 7.05556 14.6341V11.3008M15.9444 5.74523V2.41189C15.9444 2.11721 15.8274 1.83459 15.619 1.62622C15.4106 1.41784 15.128 1.30078 14.8333 1.30078H2.61111C2.31643 1.30078 2.03381 1.41784 1.82544 1.62622C1.61706 1.83459 1.5 2.11721 1.5 2.41189V14.6341L5.20333 11.5563C5.40333 11.3919 5.65444 11.3008 5.91444 11.3008H7.05556M15.9444 5.74523V10.1897C15.9444 10.4844 15.8274 10.767 15.619 10.9753C15.4106 11.1837 15.128 11.3008 14.8333 11.3008H7.05556",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsInterview);
export default __webpack_public_path__ + "static/media/MSInterview.9d3ae7bcfd9b5c81f642a37bc7c4140a.svg";
export { ForwardRef as ReactComponent };